export enum FieldElementType {
  Icon = 'ICON',
  SvgIcon = 'SVG_ICON',
  Component = 'COMPONENT',
  Template = 'TEMPLATE',
}
